// extracted by mini-css-extract-plugin
export default {"full":"CreateDealModal_full__N1nhU","funnelStage":"CreateDealModal_funnelStage__Y3vOt","defaultValueWarning":"CreateDealModal_defaultValueWarning__WLJoM"};